import { PrazoService } from '@app/services/prazo.service';
import { Component, OnInit, Input } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';

import { FuncionarioService } from '@app/services/funcionario.service';
import { Funcionario } from '@app/models/funcionario';
import { MeAvise } from '@app/models/me-avise';

@Component({
  selector: 'app-me-avise-prazo',
  templateUrl: './me-avise-prazo.component.html',
})
export class MeAvisePrazoComponent implements OnInit {

  @Input() meAvise: MeAvise[];

  cdsMask: CDSMask = new CDSMask();
  lstUsuarios: Funcionario[];

  constructor(
    private funcionarioService: FuncionarioService,
    private prazoService: PrazoService,
  ) { }

  ngOnInit() {
    this.funcionarioService.obterAdvogados().subscribe((data: Funcionario[]) => this.lstUsuarios = data);
  }

  calculaPrazo() {
    // this.prazoService.calculaPrazo(this.meAvise.Data, this.meAvise.Dias).subscribe(data => {
    //  this.meAvise.DataReal = data.dataReal;
    //   //  this.meAvise.DataFatal = data.dataFatal;
    // });
  }
}
